module.exports = __webpack_public_path__ + "static/media/file-html.a521164c.svg";